var map = {
	"./ProductDetails": 276,
	"./ProductDetails.jsx": 276,
	"./ProductTabs": 233,
	"./ProductTabs.jsx": 233,
	"./Rating": 234,
	"./Rating.jsx": 234,
	"./language-de": 604,
	"./language-de.js": 604,
	"./language-en": 605,
	"./language-en.js": 605,
	"./language-fr": 606,
	"./language-fr.js": 606,
	"./language-it": 607,
	"./language-it.js": 607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1125;